import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms"

export function firstnameValidator() : ValidatorFn {
    return (control:AbstractControl<string>) : ValidationErrors | null => {
      const value = control.value.trim()
  
      if(!value.length) {
        return { isEmpty : true }
      } else {
        // the string contains one or several special characters and/or one or several spaces
        const specialCharacterPattern = /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/

        if(specialCharacterPattern.test(value)){
          return { invalid : true }
        }
  
        // the string is a valid firstname
        return null
      }
    }
  }